// Category metadata for group documents (aligns with backend com.avocash.document.domain.DocumentCategory)
export const DOCUMENT_CATEGORIES = [
  { id: 'PDF', labelKey: 'documents.categoryPdf', icon: 'doc_text_fill', materialIcon: 'picture_as_pdf', color: '#e0483e' },
  { id: 'IMAGE', labelKey: 'documents.categoryImage', icon: 'photo_fill', materialIcon: 'image', color: '#0a84ff' },
  { id: 'VIDEO', labelKey: 'documents.categoryVideo', icon: 'video_fill', materialIcon: 'videocam', color: '#af52de' },
  { id: 'SPREADSHEET', labelKey: 'documents.categorySpreadsheet', icon: 'table', materialIcon: 'table_chart', color: '#34c759' },
  { id: 'DOCUMENT_TEXT', labelKey: 'documents.categoryDocumentText', icon: 'doc_richtext', materialIcon: 'description', color: '#5e5ce6' },
  { id: 'ARCHIVE', labelKey: 'documents.categoryArchive', icon: 'archivebox_fill', materialIcon: 'folder_zip', color: '#ff9f0a' },
  { id: 'OTHER', labelKey: 'documents.categoryOther', icon: 'doc_fill', materialIcon: 'draft', color: '#8e8e93' },
]

export function documentCategoryMeta(id) {
  return DOCUMENT_CATEGORIES.find((c) => c.id === id) || DOCUMENT_CATEGORIES[DOCUMENT_CATEGORIES.length - 1]
}

export function fmtSize(bytes) {
  if (bytes == null || bytes === 0) return ''
  const units = ['B', 'KB', 'MB', 'GB']
  let value = Number(bytes)
  let unit = 0
  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024
    unit += 1
  }
  return `${value >= 10 || unit === 0 ? Math.round(value) : value.toFixed(1)} ${units[unit]}`
}

// Visibility levels (aligns with backend com.avocash.document.domain.GroupDocumentVisibility).
// rank: higher rank = visible to more roles.
// A viewer sees a document when their role rank >= document visibility rank.
export const DOCUMENT_VISIBILITY_LEVELS = [
  { id: 'OWNER', labelKey: 'documents.visibilityOwner', descKey: 'documents.visibilityOwnerDesc', icon: 'lock_fill', color: '#ff453a', rank: 1 },
  { id: 'ADMIN', labelKey: 'documents.visibilityAdmin', descKey: 'documents.visibilityAdminDesc', icon: 'shield_fill', color: '#ff9f0a', rank: 2 },
  { id: 'MEMBERS', labelKey: 'documents.visibilityMembers', descKey: 'documents.visibilityMembersDesc', icon: 'person_2_fill', color: '#34c759', rank: 3 },
  { id: 'GUEST', labelKey: 'documents.visibilityGuest', descKey: 'documents.visibilityGuestDesc', icon: 'globe', color: '#0a84ff', rank: 4 },
]

export function documentVisibilityMeta(id) {
  return DOCUMENT_VISIBILITY_LEVELS.find((v) => v.id === id) || DOCUMENT_VISIBILITY_LEVELS[2]
}
